import React from 'react'

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';

import 'swiper/swiper.scss';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    recognisedSection: {
        backgroundImage: "url(/pitchbattle/images/wave.svg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPositionY: "center",
        paddingTop: "40px",
        paddingBottom: "40px",
        "& .container": {
            maxWidth: "1080px",
        },
        "& .swiper-slide img": {
            maxWidth: "200px",
            margin: "auto"
        },
        "& p": {
            textAlign: 'center',
            marginBottom: '30px',
            fontSize: '30px',
            fontWeight: '600',
            '@media screen and (max-wdith: 480px)': {
                fontSize: '25px',
            },
        },
        '@media screen and (max-wdith: 480px)': {
            paddingTop: "20px",
            paddingBottom: "20px",
        },
    },
    recognisedContainer: {
        padding: '30px',
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 5px 10px rgb(0 0 0 / 5%)',
    }
});

function Recognised() {
    SwiperCore.use([Autoplay]);

    var classes = useStyles()

    return (
        <div className={classes.recognisedSection}>
            <div className="container">
                <div className={classes.recognisedContainer}>
                    <p>Recognised By</p>
                    <Swiper style={{cursor: "grab"}}
                    spaceBetween={50}
                    slidesPerView={7}
                    loop="true"
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    autoplay={{
                        delay: 3000,
                        // disableOnInteraction: true
                    }}
                    breakpoints={{
                        // when window width is >= 320px
                        320: {
                        slidesPerView: 1,
                        spaceBetween: 20
                        },
                        // when window width is >= 480px
                        480: {
                        slidesPerView: 3,
                        spaceBetween: 30
                        },
                        // when window width is >= 640px
                        /*640: {
                        slidesPerView: 4,
                        spaceBetween: 40
                        },
                        // when window width is >= 800px
                        800: {
                        slidesPerView: 5,
                        spaceBetween: 50
                        },
                        // when window width is >= 1000px
                        1000: {
                        slidesPerView: 6,
                        spaceBetween: 50
                        },*/
                        // when window width is >= 1200px
                        1200: {
                        slidesPerView: 3,
                        spaceBetween: 100
                        }
                    }}
                    onSlideChange={() => console.log('slide change')}
                    onSwiper={(swiper) => console.log(swiper)}
                    >
                        {/* <SwiperSlide>
                            <img src="/pitchbattle/images/aicgusec.png" alt="AIC GUSEC"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src="/pitchbattle/images/aiie.png" alt="AIIE"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src="/pitchbattle/images/nxgventures.png" alt=""/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src="/pitchbattle/images/ssip.png" alt="SSIP"/>
                        </SwiperSlide> */}
                        <SwiperSlide>
                            <img src="/pitchbattle/images/wf_logo.png" alt="Wadhwani Foundation"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src="/pitchbattle/images/hostel-fund-logo.png" alt="Hostel Fund"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src="/pitchbattle/images/awadh-logo.png" alt="IIT Ropar Awadh"/>
                        </SwiperSlide>
                        {/* <SwiperSlide>
                            <img src="/pitchbattle/images/nen.png" alt="National Entrepreneurship Network"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src="/pitchbattle/images/yahoofinance.png" alt="Yahoo Finance"/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src="/pitchbattle/images/yourstory.png" alt="Your Story"/>
                        </SwiperSlide> */}

                        <div className="swiper-button-prev"></div>
                        <div className="swiper-button-next"></div>
                    </Swiper>
                </div>
            </div>
        </div>
    )
}

export default Recognised
